import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { DELIVERY_PLAN_AUDIT_LIST } from '../../actions';
import { DeliveryPlanAuditListSuccess, DeliveryPlanAuditListError } from '../../actions';

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
        }, reject);
    });
}

const onListAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'delivery_plan/audit/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(r => r.json()).catch(err => console.log(err));
    return { data: response };
};

function* onList(action) {
    try {
        const response = yield call(onListAsync, action.payload);
        yield put(DeliveryPlanAuditListSuccess(response.data.data || []));
    } catch (error) {
        yield put(DeliveryPlanAuditListError(error));
    }
}

function* watchList() { yield takeEvery(DELIVERY_PLAN_AUDIT_LIST, onList); }

export default function* rootSaga() {
    yield all([fork(watchList)]);
}
